<template>
  <el-dialog
      :visible.sync="show"
      width="400px"
      :close-on-click-modal="false"
      @close="close"
  >
    <div class="qrcode-layer">
      <qrcode :value="data"/>
    </div>
  </el-dialog>
</template>

<script>
import Qrcode from "@/components/Qrcode";

export default {
  name: "QrcodeLayer",
  components: {Qrcode},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: String
  },
  data() {
    return {
      show: false
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.show = val
        }
      }
    }
  },
  methods: {
    /**
     * 关闭
     */
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped lang="scss">
.qrcode-layer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>